import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Box, makeStyles, Button } from "@material-ui/core";
import { backend } from "../../../api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    width: "90%",
    margin: "20px auto",
  },
  modalHeading: {
    fontSize: 24,
    fontWeight: 550,
    marginBottom: 0,
  },
  modalLine: {
    margin: "20px auto",
    width: "100%",
    color: theme.palette.secondary.dark,
  },
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
  },
  submitBtn: {
    color: theme.palette.secondary.light,
    backgroundColor: theme.palette.primary.main,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.secondary.dark,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    color: theme.palette.secondary.light,
  },
  dropZoneContainer: {
    padding: "0 5px",
    maxHeight: 100,
    margin: 0,
  },
  text: {
    color: "red",
  },
  preview: {
    backgroundColor: "red",
    marginTop: "-50px",
    padding: 0,
    maxHeight: 50,
  },
  prevviewImage: {
    margin: 0,
  },
}));

function BuyArticle(props) {
  const { visible, closeModal, article, user, tax } = props;
  const classes = useStyles();
  const [articlePrice, setArticlePrice] = useState(
    parseInt(article.number_of_pages) * parseInt(article.per_page_price)
  );
  const [taxValue, setTaxValue] = useState(
    (articlePrice * (parseInt(tax) / 100)).toFixed(0)
  );

  const placeArticeOrder = () => {
    const newOrder = {
      total_price: parseInt(articlePrice) + parseInt(taxValue),
      source_of_approaching: "family",
      user: user._id,
      article: article._id,
      billing_details: {
        payment_type: "paypal",
        per_page_price: article.per_page_price,
        number_of_pages: article.number_of_pages,
        tax_amount: {
          percentage: tax,
          amount: taxValue,
        },
      },
    };

    backend
      .post("/articleOrder", newOrder)
      .then((res) => {
        closeModal();
        Swal.fire({
          title: "Congratulations",
          icon: "success",
          confirmButtonText: "OK",
          text: res.data.message,
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = article.pdf_file;
        downloadLink.download = "article.pdf";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };
  return (
    <Modal
      width="500"
      visible={visible}
      effect="fadeInUp"
      onClickAway={closeModal}
    >
      <div className={classes.modalContainer}>
        <h3 className={classes.modalHeading}>{article.article_title}</h3>
        <hr className={classes.modalLine} />

        <p>
          <b>Per Page Price: </b> ${article.per_page_price}
        </p>
        <p>
          <b>Total Pages: </b>
          {article.number_of_pages}
        </p>
        <Box textAlign="right">
          <p>
            <b>Subtotal: </b>${articlePrice}
          </p>
          <p>
            <b>Tax: </b>${taxValue}
          </p>
          <h4>TOTAL: ${parseInt(articlePrice) + parseInt(taxValue)}</h4>
        </Box>

        <Box mt={5} display="flex" justifyContent="space-between">
          <Button className={classes.cancelBtn} onClick={closeModal}>
            Cancel
          </Button>
          <Button className={classes.submitBtn} onClick={placeArticeOrder}>
            Checkout
          </Button>
        </Box>
      </div>
    </Modal>
  );
}
export default BuyArticle;
